import React from 'react';
import { useSelector } from 'react-redux';
import { CircularProgress, Grid, TextField } from '@material-ui/core';

const InfoLineCompany = ({ selectedLine, loadingLine, inputProps, hideEmpresa }) => {

  const isStrip = useSelector(state => state.line.isStrip);

  if (loadingLine) {
    return (
      <Grid item xs={12}>
        <Grid item xs={12} sm={5}>
          <CircularProgress size={16} />
        </Grid>
      </Grid>);
  }

  return (
    <>
      {isStrip && !hideEmpresa && (
        <Grid item xs={12} sm={6}>
          <TextField
            {...inputProps}
            label='Empresa'
            name='deRazaoSocial'
            value={selectedLine?.empresa?.deRazaoSocial || ""}
            disabled
            variant='filled'
            fullWidth
            InputLabelProps={{ shrink: true }}
            InputProps={{readOnly: true}}
          />
        </Grid>
      )}
      <Grid item xs={12} sm={6}>
        <TextField
          {...inputProps}
          label='Linha'
          name='deNome'
          value={selectedLine?.deDescricao || ""}
          disabled
          variant='filled'
          fullWidth
          InputLabelProps={{ shrink: true }}
          InputProps={{readOnly: true}}
        />
      </Grid>
    </>
  );
};

export default InfoLineCompany;